import {
  Alert,
  Box,
  Button,
  Card,
  CardContent,
  Divider,
  Fab,
  Grid,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import * as React from "react";
import { PaymentsFormType } from "../../types/entitiesModel";
import { ERROR_MESSAGE, OK_MESSAGE } from "../../utils/Constants";
import { CheckCircleOutline } from "@mui/icons-material";
import { messageType } from "../../types/otherTypes";
import { useNavigate } from "react-router-dom";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import { typePaymentSelectType } from "../../utils/SelectData";
import { removeAccentsAndToLower } from "../../utils/Utils";
import { AuthContext } from "../../context/AuthContext";


const CreatePayment: React.FC = () => {
  const { token } = React.useContext(AuthContext) || {};
  const navigate = useNavigate();

  const [formState, setFormState] = React.useState<PaymentsFormType>({
    account_name: "",
    document: "",
    account_number: "",
    type: "",
    type_id: 0,
  });

  const [message, setMessage] = React.useState<messageType>({
    message: "",
    type: OK_MESSAGE, // can change
  });

  /**
   * To handle form data
   *
   * @param event
   */
  const handleChangeForm = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = event.target;

    setFormState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleBackView = () => {
    navigate("/admin/payments");
  };

  /**
   * Send data to api, to save the payment
   */
  const handleSubmit = async () => {
    const requestBody = {
      account_name: formState.account_name,
      document: formState.document,
      account_number: formState.account_number,
      type: formState.type,
    };

    try {
      const response = await fetch("/api/payments", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(requestBody),
      });

      if (response.ok) {
        const responseData = await response.json();

        setMessage({
          message: `Success: ${
            responseData.messages || "Data enviada con éxito"
          }`,
          type: OK_MESSAGE,
        });

        setTimeout(() => {
          navigate("/admin/payments");
        }, 1000);
      } else {
        const errorData = await response.json();
        setMessage({
          message: `Error: ${errorData.message || "Algo ha ido mal"}`,
          type: ERROR_MESSAGE,
        });
      }
    } catch (error: unknown) {
      if (error instanceof Error) {
        setMessage({
          message: `Error: ${
            error.message || "Ha ocurrido un error inesperado"
          }`,
          type: ERROR_MESSAGE,
        });
      } else {
        setMessage({
          message: "Error: Error desconocido",
          type: ERROR_MESSAGE,
        });
      }
    }
  };

  return (
    <React.Fragment>
      <Grid container spacing={0}>
        {message.message !== "" &&
          (message.type === OK_MESSAGE ? (
            <Alert
              icon={<CheckCircleOutline fontSize="inherit" />}
              severity="success"
              sx={{
                mx: "auto",
                mb: 2,
                width: "95%",
              }}
            >
              {message.message}
            </Alert>
          ) : (
            <Alert
              sx={{
                m: "auto",
                mb: 2,
                width: "95%",
              }}
              severity="error"
            >
              {message.message}
            </Alert>
          ))}
        <Fab
          color="primary"
          variant="extended"
          sx={{
            mr: 1,
            mb: {
              xs: 1,
              sm: 0,
              lg: 0,
            },
            ml: 2,
          }}
          onClick={handleBackView}
        >
          <KeyboardDoubleArrowLeftIcon />
          <Typography
            sx={{
              ml: 1,
              textTransform: "capitalize",
            }}
          >
            {"Tabla de pagos"}
          </Typography>
        </Fab>
        <Grid item lg={12} md={12} xs={12}>
          <div>
            <Card
              variant="outlined"
              sx={{
                p: 0,
              }}
            >
              <Box
                sx={{
                  padding: "15px 30px",
                }}
                display="flex"
                alignItems="center"
              >
                <Box flexGrow={1}>
                  <Typography
                    sx={{
                      fontSize: "18px",
                      fontWeight: "500",
                    }}
                  >
                    Creación de nuevo pago
                  </Typography>
                </Box>
              </Box>
              <Divider />
              <CardContent
                sx={{
                  padding: "30px",
                }}
              >
                <form>
                  {/* Nombre de la cuenta y Documento */}
                  <Grid container spacing={2}>
                    <Grid item md={6} xs={12}>
                      <TextField
                        id="account_name"
                        label="Nombre de Banco/Servicio"
                        variant="outlined"
                        placeholder="Nombre de cuenta"
                        fullWidth
                        sx={{
                          mb: 2,
                        }}
                        name="account_name"
                        onChange={handleChangeForm}
                      />
                      <TextField
                        id="document"
                        label="Documento o Correo"
                        type="text"
                        variant="outlined"
                        placeholder="Documento o Correo"
                        fullWidth
                        sx={{
                          mb: 2,
                        }}
                        name="document"
                        onChange={handleChangeForm}
                      />
                    </Grid>
                    {/* Número de cuenta y tipo */}
                    <Grid item md={6} xs={12}>
                      <TextField
                        id="account_number"
                        label="Número de cuenta"
                        type="text"
                        variant="outlined"
                        placeholder="Número de cuenta"
                        fullWidth
                        sx={{
                          mb: 2,
                        }}
                        name="account_number"
                        onChange={handleChangeForm}
                      />
                      <TextField
                        fullWidth
                        id="tipe_id"
                        variant="outlined"
                        select
                        label="Tipo"
                        name="type"
                        value={formState.type_id}
                        onChange={(event) => {
                          const newValue = Number(event.target.value);
                          const selectedType = typePaymentSelectType.find(
                            (type) => type.value === newValue
                          );
                          if (selectedType) {
                            setFormState((prevState: any) => ({
                              ...prevState,
                              type_id: newValue,
                              type: removeAccentsAndToLower(selectedType.label),
                            }));
                          }
                        }}
                        sx={{ mb: 2 }}
                      >
                        <MenuItem value={"0"}>
                          {"Seleccione si divisas o bolívares"}
                        </MenuItem>
                        {Array.isArray(typePaymentSelectType) &&
                        typePaymentSelectType.length > 0 ? (
                          typePaymentSelectType.map((type) => (
                            <MenuItem key={type.value} value={type.value}>
                              {type.label}
                            </MenuItem>
                          ))
                        ) : (
                          <MenuItem disabled value="">
                            No hay tipos disponibles
                          </MenuItem>
                        )}
                      </TextField>
                    </Grid>
                  </Grid>
                  <Grid container>
                    <Button
                      onClick={() => {
                        handleSubmit();
                      }}
                      color="primary"
                      variant="contained"
                    >
                      Enviar
                    </Button>
                  </Grid>
                </form>
              </CardContent>
            </Card>
          </div>
        </Grid>
      </Grid>
    </React.Fragment>
  );
};

export default CreatePayment;
